<template>
  <div class="card tile is-child">
    <div class="card-image">
      <figure class="image is-4by3" v-on:click="extendVeranstaltung" style="cursor: pointer;">
        <img :src="getImgUrl(image)" alt="Veranstaltungsbild" />
      </figure>
    </div>

    <div class="card-content">
      <div class="media">
        <div class="media-content">
          <p class="title is-4">{{ titel }}</p>
          <p class="subtitle is-6">
            {{ beginn | dayFilter("dddd, DD.MM.YYYY") }} <br />
            {{ beginn | dayFilter("HH.mm") }} Uhr
          </p>
        </div>
      </div>

      <div class="content has-text-left">
        <p v-if="!awesome" v-on:click="openAndExtend" style="cursor: pointer;">
          {{ beschreibung | truncate(120, '...') }}
          <a class="has-text-link">Weiterlesen</a>
        </p>

        <div v-if="awesome">
          <p v-html="beschreibung"></p>
          
          <div style="margin-top:10px">
            <p class="title is-5">Ort</p>
            <p class="subtitle is-6">{{ ort }}</p>
          </div>

          <div class="media" style="margin-top:40px; margin-left:-35px">
            <div class="media-left">
              <figure class="image is-64x64">
                <img class="is-rounded" :src="getAnsprechpartnerImg(ansprechpartnerBild)" />
              </figure>
            </div>
            <div class="media-content">
              <p class="title is-4">{{ ansprechpartner }}</p>
              <p class="subtitle">
                <a class="button is-link" v-if="!mailForm" v-on:click="showKontaktformular(!mailForm)">
                  E-Mail schreiben
                </a>
              </p>
            </div>
          </div>

          <Kontaktformular 
            :empfaenger="ansprechpartnerMail" 
            :showKontaktFormular="mailForm"
            @show-kontaktformular="showKontaktformular" 
          />
        </div>
      </div>
    </div>

    <div v-if="showOverlay && titel === 'NachSINNKonzert'" class="custom-overlay" @click.self="closeOverlay">
      <div class="modal-content">
        <button class="close-button" @click="closeOverlay" title="Schließen (ESC)">&times;</button>
        <img src="https://cg-karlsruhe.de/img/NachSINNKonzert.jpeg" alt="Info Bild">
      </div>
    </div>
  </div>
</template>

<script>
import Kontaktformular from '@/components/Kontaktformular.vue'

// Globaler Merker für die gesamte Sitzung
let globalImageShown = false;

export default {
  name: 'KalenderVeranstaltung',
  components: { Kontaktformular },
  props: {
    titel: String,
    beschreibung: String,
    beginn: String,
    ende: String,
    image: String,
    ansprechpartner: String,
    ansprechpartnerBild: String,
    ansprechpartnerMail: String,
    ort: String
  },
  data() {
    return {
      awesome: false,
      mailForm: false,
      showOverlay: false
    }
  },
  methods: {
    openAndExtend() {
      // PRÜFUNG: Nur wenn der Titel stimmt UND es global noch nicht gezeigt wurde
      if (this.titel === 'NachSINNKonzert' && !globalImageShown) {
        this.showOverlay = true;
        globalImageShown = true;
        window.addEventListener('keydown', this.handleEscKey);
      }
      
      // Text wird bei JEDER Veranstaltung ausgeklappt
      this.awesome = true;
    },

    closeOverlay() {
      this.showOverlay = false;
      window.removeEventListener('keydown', this.handleEscKey);
    },

    handleEscKey(e) {
      if (e.key === "Escape") {
        this.closeOverlay();
      }
    },

    extendVeranstaltung() {
      this.awesome = !this.awesome;
    },

    showKontaktformular(showMailmForm) {
      this.mailForm = showMailmForm;
    },

    getImgUrl(pic) {
      return pic;
    },

    getAnsprechpartnerImg(pic) {
      try {
        return require('../assets/ansprechpartner/' + pic);
      } catch (e) {
        return '';
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleEscKey);
  }
}
</script>

<style scoped>
.custom-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.1); 
  backdrop-filter: blur(4px); 
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  position: relative;
  max-width: 90%;
  max-height: 85%;
  display: flex;
  justify-content: center;
  animation: fadeIn 0.3s ease-out;
}

.modal-content img {
  border-radius: 12px;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.3);
  max-width: 100%;
  max-height: 85vh;
  object-fit: contain;
  background-color: white;
}

.close-button {
  position: absolute;
  top: -55px;
  right: 0;
  background: none;
  border: none;
  color: #333;
  font-size: 50px;
  font-weight: 300;
  cursor: pointer;
  line-height: 1;
  transition: color 0.2s;
}

.close-button:hover {
  color: #ff3860;
}

@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}
</style>